// src/pages/Login.js
import React from 'react';

export default function Login({ onLogin }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0D1B2A 0%, #1A2E44 50%, #243C58 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
      padding: 20
    }}>
      {/* Decoración geométrica de fondo */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundImage: `radial-gradient(circle at 20% 80%, rgba(232,134,58,0.08) 0%, transparent 50%),
                          radial-gradient(circle at 80% 20%, rgba(232,134,58,0.05) 0%, transparent 50%)`,
        pointerEvents: 'none'
      }} />

      <div style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        {/* Logo y nombre */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            width: 68, height: 68,
            background: '#E8863A',
            borderRadius: 16,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
            fontSize: 32, fontWeight: 800, color: 'white',
            boxShadow: '0 8px 24px rgba(232,134,58,0.35)'
          }}>A</div>
          <h1 style={{ color: 'white', fontSize: 26, fontWeight: 700, letterSpacing: '0.04em', marginBottom: 4 }}>
            ARCSEG
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>
            Ingeniería Hidráulica · BIM · SIG
          </p>
        </div>

        {/* Card de login */}
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: 16, padding: '32px 36px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: 'white', fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
            Portal Interno
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, marginBottom: 28, lineHeight: 1.6 }}>
            Accede con tu cuenta corporativa ARCSEG
          </p>

          <button
            onClick={onLogin}
            style={{
              width: '100%', padding: '13px 20px',
              background: 'white',
              border: 'none', borderRadius: 10,
              cursor: 'pointer', fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
              fontWeight: 500, fontSize: 14,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              transition: 'transform 0.15s, box-shadow 0.15s',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={e => { e.target.style.transform = 'translateY(-1px)'; e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)'; }}
            onMouseLeave={e => { e.target.style.transform = ''; e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)'; }}
          >
            <GoogleIcon />
            Continuar con Google
          </button>

          <div style={{ marginTop: 20, padding: '12px 16px', background: 'rgba(232,134,58,0.1)', borderRadius: 8, border: '1px solid rgba(232,134,58,0.2)' }}>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, lineHeight: 1.5 }}>
              🔒 Acceso restringido al equipo ARCSEG<br />
              Usa tu cuenta <strong style={{ color: 'rgba(255,255,255,0.8)' }}>@arcseg-ec.com</strong>
            </p>
          </div>
        </div>

        {/* Footer */}
        <p style={{ textAlign: 'center', marginTop: 24, color: 'rgba(255,255,255,0.25)', fontSize: 12 }}>
          Sistema Integrado v2.0 · Quito, Ecuador · 2025
        </p>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
  );
}
